import BackgroundForm from './form/BackgroundForm';
import Page from '../Page';

function PageForm({children , className}) {
    return (
        <Page>
            <BackgroundForm className={className}>
                {children}
            </BackgroundForm>
        </Page>
    )
}

export default PageForm;